var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDappBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 50,
    viewBox: "0 0 61 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.5265 15H0.671387V0H40.5265V15ZM43.0174 0V15H60.454V0H43.0174ZM0.671387 50H40.5265V35H0.671387V50ZM43.0174 50H60.454V35H43.0174V50ZM20.5989 32.5H60.454V17.5H20.5989V32.5ZM18.108 17.5H0.671387V32.5H18.108V17.5Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDappBuilder);
export default __webpack_public_path__ + "static/media/dappBuilder.8c133d730eeb7ccd5b63041aa9387be9.svg";
export { ForwardRef as ReactComponent };